import React from 'react';
import { Card } from '@ncoder/ui';
import { DeploymentStatusItem } from '../../atoms/deployment';
import { CheckCircle, Server, Tag } from 'lucide-react';

interface DeploymentStatusPanelProps {
  activeDeployments: number;
  totalEnvironments: number;
  currentVersion: string;
}

export const DeploymentStatusPanel: React.FC<DeploymentStatusPanelProps> = ({
  activeDeployments,
  totalEnvironments,
  currentVersion,
}) => {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Deployment Status</h3>
      <div className="space-y-4">
        <DeploymentStatusItem
          label="Active Deployments"
          value={activeDeployments}
          icon={<CheckCircle className="h-4 w-4" />}
          variant="default"
        />
        <DeploymentStatusItem
          label="Total Environments"
          value={totalEnvironments}
          icon={<Server className="h-4 w-4" />}
          variant="secondary"
        />
        <DeploymentStatusItem
          label="Current Version"
          value={currentVersion}
          icon={<Tag className="h-4 w-4" />}
          variant="default"
        />
      </div>
    </Card>
  );
};
